'use client'

import { usePathname, useSearchParams } from 'next/navigation'
import { useEffect, useRef } from 'react'
import * as Sentry from '@sentry/nextjs'

/**
 * Use this hook in the root layout or in a global client-side component.
 * Automatically captures route transitions for Sentry Performance + Replay.
 */
export const useSentryRoutePerf = () => {
  const pathname = usePathname()
  const searchParams = useSearchParams()
  const prevFullPath = useRef(`${pathname}?${searchParams.toString()}`)

  useEffect(() => {
    const currentFullPath = `${pathname}?${searchParams.toString()}`

    if (prevFullPath.current !== currentFullPath) {
      // Capture the route transition start in Sentry
      Sentry.captureRouterTransitionStart(prevFullPath.current, currentFullPath)

      // Update previous path
      prevFullPath.current = currentFullPath
    }
  }, [pathname, searchParams])
}
